import { useQuery } from '@tanstack/react-query';
import { type ReactNode } from 'react';
import { EmptyState, PriceTag, Skeleton, orderListSummary } from '@aps/ui';
import { useNavigation } from '../app/navigation.js';
import { useSettings } from '../app/settings.js';
import { canOrder } from '../app/session.js';
import { api } from '../lib/api.js';

/**
 * 1-QATLAM: buyurtmalar ro'yxati.
 *
 * Bitta sana — eng sekin qismniki. Erta tayyor bo'ladigan qism alohida
 * IJOBIY qator bo'lib chiqadi. PROGRESS BAR YO'Q (docs/02-MAHSULOT.md).
 *
 * Mantiq `@aps/ui/orderListSummary` da va u yerda test bilan qoplangan —
 * ekran faqat chizadi.
 */
export function OrdersScreen(): ReactNode {
  const { t, locale } = useSettings();
  const { push } = useNavigation();

  const orders = useQuery({
    queryKey: ['orders'],
    queryFn: api.orders,
    retry: false,
    enabled: canOrder(),
  });

  if (orders.isPending) {
    return (
      <div className="aps-screen">
        <Skeleton height="96px" />
        <Skeleton height="96px" />
      </div>
    );
  }

  const items = orders.data?.items ?? [];

  return (
    <div className="aps-screen">
      <h1 className="aps-screen__title">{t('orders.title')}</h1>

      {items.length === 0 ? (
        <EmptyState title={t('orders.empty')} hint={t('orders.emptyHint')} />
      ) : (
        <div className="aps-stack">
          {items.map((order) => {
            const summary = orderListSummary(order, locale);
            return (
              <button
                key={order.id}
                type="button"
                className="aps-shipment"
                onClick={() => {
                  push({ name: 'order', id: order.id });
                }}
              >
                <span className="aps-shipment__body">
                  <span className="aps-garage__title">
                    {t('orders.number')} #{order.number}
                  </span>
                  <span className="aps-shipment__status">
                    {order.itemCount} {t('orders.items')} · {summary.sub}
                  </span>
                  {summary.early === null ? null : (
                    <span className="aps-stock aps-stock--here">{summary.early}</span>
                  )}
                </span>
                <span className="aps-shipment__aside">
                  <span className="aps-shipment__eta">{summary.headline}</span>
                  <PriceTag
                    value={order.grandTotal}
                    locale={locale}
                    size="sm"
                    showDiscount={false}
                  />
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
